import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll sur body (desktop)
    document.body.scrollTo({ top: 0, behavior: 'auto' });

    // Scroll sur window (fallback)
    window.scrollTo({ top: 0, behavior: 'auto' });

    // Scroll sur document.documentElement
    document.documentElement.scrollTo({ top: 0, behavior: 'auto' });

    // IMPORTANT : Scroll sur .content (mobile - max-width: 1200px)
    const contentElement = document.querySelector('.content');
    if (contentElement) {
      contentElement.scrollTo({ top: 0, behavior: 'auto' });
    }

    // Scroll sur .content-body (au cas où)
    const contentBody = document.querySelector('.content-body');
    if (contentBody) {
      contentBody.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
